import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/** Old stage pages open the single Orders list with the matching filter. ?ready=1 → To pack. The old lists stay at /admin/orders/legacy/*. */
export default function LegacyOrdersRedirect({ filter }) {
  const { search } = useLocation();
  const p = new URLSearchParams(search);
  const f = p.get("ready") === "1" ? "to_pack" : filter === "to_pack" && !p.get("ready") ? "all" : filter;
  const q = p.get("q") ? `&q=${encodeURIComponent(p.get("q"))}` : "";
  return <Navigate to={`/admin/orders${f && f !== "all" ? `?filter=${f}${q}` : q ? `?${q.slice(1)}` : ""}`} replace />;
}
